import { render, staticRenderFns } from "./BtnSpinner.vue?vue&type=template&id=2fb34ef4"
var script = {}
import style0 from "./BtnSpinner.vue?vue&type=style&index=0&id=2fb34ef4&prod&lang=sass"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports